export const BASE = "/api";

import { tryRefreshSession } from "../session-refresh";

export { tryRefreshSession };

/**
 * Same-origin API fetch with cookies. On 401, attempts one refresh then retries.
 * Redirects to /login if still unauthorized (except when already on login).
 */
export async function apiFetch(
  input: string,
  init?: RequestInit,
): Promise<Response> {
  const first = await fetch(input, {
    credentials: "include",
    ...init,
  });
  if (first.status !== 401) return first;
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/login")) {
    return first;
  }
  if (await tryRefreshSession()) {
    return fetch(input, { credentials: "include", ...init });
  }
  if (typeof window !== "undefined") {
    window.location.href = "/login";
  }
  return first;
}

export function workspaceHeaders(workspaceId: string): HeadersInit {
  return { "X-Workspace-ID": workspaceId };
}

/** Clears httpOnly session cookies and sends the browser to the login page. */
export async function logoutDashboard(): Promise<void> {
  await fetch(`${BASE}/auth/logout`, { method: "POST", credentials: "include" });
  if (typeof window !== "undefined") {
    window.location.href = "/login";
  }
}
